import {
  CircularProgress,
  FormControl,
  FormControlLabel,
  Grid,
  InputLabel,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
} from "@mui/material";
import PropTypes from "prop-types";
import React, { useCallback, useEffect, useRef, useState } from "react";

import { ReactComponent as IconPorcenteNegative } from "../../assets/icons/icon-porcent-negative.svg";
import { ReactComponent as IconPorcentePositive } from "../../assets/icons/icon-porcent-positive.svg";
import Card from "../../components/Cards/Card";
import { Footer } from "../../components/Footer/Footer";
import LayoutWrapper from "../../components/LayoutWrapper/LayoutWrapper";
import NativeObject from "../../components/NativeObject/NativeObject";
import { useSelections } from "../../context/Selections";

const OBJECTS_BIGNUMBERS = [
  {
    TITLE: "vTexto_Positivacao",
    CURRENT: "LqjpJh",
    VALUE: "QwYbFt",
    PORCENT: "MNvpF",
    DESTAQUE: true,
  },
  {
    TITLE: "vTexto_Penetracao",
    CURRENT: "DpTPrU",
    VALUE: "rCJEmr",
    PORCENT: "nPEPAj",
    DESTAQUE: true,
  },
  {
    TITLE: "vTexto_GiroPDV",
    CURRENT: "NKVQkq",
    VALUE: "jLScPSb",
    PORCENT: "kyNEyWd",
    DESTAQUE: true,
  },
  {
    TITLE: "vTexto_Volume",
    CURRENT: "NqXBPq",
    VALUE: "PYVXH",
    PORCENT: "QQgyp",
    DESTAQUE: false,
  },
  {
    TITLE: "vTexto_Preco",
    CURRENT: "xmmHYA",
    VALUE: "LLNHT",
    PORCENT: "GymPgs",
    DESTAQUE: true,
  },
  {
    TITLE: "vTexto_SellOut",
    CURRENT: "CbArCnm",
    VALUE: "ynLfn",
    PORCENT: "MzcbJe",
    DESTAQUE: false,
  },
  {
    TITLE: "vTexto_TOP10",
    CURRENT: "NEjDt",
    VALUE: "xBSXeN",
    PORCENT: "pTCehb",
    DESTAQUE: true,
  },
  {
    TITLE: "vTexto_PercTOP10",
    CURRENT: "HUPLQFe",
    VALUE: "XHcszQp",
    PORCENT: "TYWKvGt",
    DESTAQUE: true,
  },
];

// Títulos fixos no front-end para eliminar chamadas de variáveis do Qlik
const HARD_TITLES_OVERVIEW = [
  "Positivação",
  "SKU Penetração",
  "Giro PDV",
  "Volume (Un)",
  "Preço Médio (Un)",
  "Sell Thru (R$)",
  "TOP Produtos",
  "% Penetração",
];

  const OBJECTS_ID = {
  INPUT_RESUL: "JqjeaV",
  TATLE_01: "UuXWeWp",
  INPUT_MEDIA: "UjwBLym",
  INPUT_PERIO: "LAAzvpQ",
  TATLE_02: "tfNQrPM",
  };

function OverviewDesktop({ app, config }) {
  const { selections } = useSelections();
  const kpiDefaultAppliedRef = useRef(false);

  const [bigNumberTitle01, setBigNumberTitle01] = useState("");
  const [bigNumberCurrent01, setBigNumberCurrent01] = useState("");
  const [bigNumberValue01, setBigNumberValue01] = useState("");
  const [bigNumberPorcente01, setBigNumberPorcente01] = useState("");

  const [bigNumberTitle02, setBigNumberTitle02] = useState("");
  const [bigNumberCurrent02, setBigNumberCurrent02] = useState("");
  const [bigNumberValue02, setBigNumberValue02] = useState("");
  const [bigNumberPorcente02, setBigNumberPorcente02] = useState("");

  const [bigNumberTitle03, setBigNumberTitle03] = useState("");
  const [bigNumberCurrent03, setBigNumberCurrent03] = useState("");
  const [bigNumberValue03, setBigNumberValue03] = useState("");
  const [bigNumberPorcente03, setBigNumberPorcente03] = useState("");

  const [bigNumberTitle04, setBigNumberTitle04] = useState("");
  const [bigNumberCurrent04, setBigNumberCurrent04] = useState("");
  const [bigNumberValue04, setBigNumberValue04] = useState("");
  const [bigNumberPorcente04, setBigNumberPorcente04] = useState("");

  const [bigNumberTitle05, setBigNumberTitle05] = useState("");
  const [bigNumberCurrent05, setBigNumberCurrent05] = useState("");
  const [bigNumberValue05, setBigNumberValue05] = useState("");
  const [bigNumberPorcente05, setBigNumberPorcente05] = useState("");

  const [bigNumberTitle06, setBigNumberTitle06] = useState("");
  const [bigNumberCurrent06, setBigNumberCurrent06] = useState("");
  const [bigNumberValue06, setBigNumberValue06] = useState("");
  const [bigNumberPorcente06, setBigNumberPorcente06] = useState("");

  const [bigNumberTitle07, setBigNumberTitle07] = useState("");
  const [bigNumberCurrent07, setBigNumberCurrent07] = useState("");
  const [bigNumberValue07, setBigNumberValue07] = useState("");
  const [bigNumberPorcente07, setBigNumberPorcente07] = useState("");

  const [bigNumberTitle08, setBigNumberTitle08] = useState("");
  const [bigNumberCurrent08, setBigNumberCurrent08] = useState("");
  const [bigNumberValue08, setBigNumberValue08] = useState("");

  const [textCurrentBigNumber, setTextCurrentBigNumber] = useState("Atual");
  const [textprevetBigNumber, setTextprevetBigNumber] = useState("Anterior");
  const [textdeltaBigNumber, setTextdeltaBigNumber] = useState("Var %");

  const [subTitle, setSubTitle] = useState(
    "Central para acompanhamento de dados"
  );
  const [subTitle01, setSubTitle01] = useState("");

  const [selectedValue, setSelectedValue] = useState("MOM");
  const [selectedKpiValue, setSelectedKpiValue] = useState("TOP 10 Farma");

  const [titleTable01, setTitleTable01] = useState("Resultados");
  const [titleTable02, setTitleTable02] = useState("Evolução ao longo do tempo");

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const getBigNumberTitle = async (titleObjetc, position) => {
    try {
      const variableModel = await app.variable.getByName(titleObjetc);
      const layout = await variableModel.getLayout();
      position === 1 && setBigNumberTitle01(layout.qText);
      position === 2 && setBigNumberTitle02(layout.qText);
      position === 3 && setBigNumberTitle03(layout.qText);
      position === 4 && setBigNumberTitle04(layout.qText);
      position === 5 && setBigNumberTitle05(layout.qText);
      position === 6 && setBigNumberTitle06(layout.qText);
      position === 7 && setBigNumberTitle07(layout.qText);
      position === 8 && setBigNumberTitle08(layout.qText);
    } catch (error) {
      console.error("Erro ao obter a variável:", error);
    }
  };

  const getBigNumberCurrent = useCallback(
    async (objectId, position) => {
      if (app && objectId) {
        let id = objectId;
        await app.visualization.get(id).then((res) => {
          const value = res?.model?.layout?.style?.label;
          position === 1 && setBigNumberCurrent01(value);
          position === 2 && setBigNumberCurrent02(value);
          position === 3 && setBigNumberCurrent03(value);
          position === 4 && setBigNumberCurrent04(value);
          position === 5 && setBigNumberCurrent05(value);
          position === 6 && setBigNumberCurrent06(value);
          position === 7 && setBigNumberCurrent07(value);
          position === 8 && setBigNumberCurrent08(value);
        });
      }
    },
    [app]
  );

  const getBigNumberValue = useCallback(
    async (objectId, position) => {
      if (app && objectId) {
        let id = objectId;
        await app.visualization.get(id).then((res) => {
          // const value =
          //   res?.model?.layout?.qHyperCube?.qGrandTotalRow[0]?.qText ??
          //   res?.model?.layout?.qHyperCube?.qGrandTotalRow[0]?.qNum ??
          //   null;
          const value = res?.model?.layout?.style?.label;
          position === 1 && setBigNumberValue01(value);
          position === 2 && setBigNumberValue02(value);
          position === 3 && setBigNumberValue03(value);
          position === 4 && setBigNumberValue04(value);
          position === 5 && setBigNumberValue05(value);
          position === 6 && setBigNumberValue06(value);
          position === 7 && setBigNumberValue07(value);
          position === 8 && setBigNumberValue08(value);
        });
      }
    },
    [app]
  );

  const getBigNumberPorcente = useCallback(
    async (objectId, position) => {
      if (app && objectId) {
        let id = objectId;
        await app.visualization.get(id).then((res) => {
          // const value =
          //   res?.model?.layout?.qHyperCube?.qGrandTotalRow[0]?.qText ??
          //   res?.model?.layout?.qHyperCube?.qGrandTotalRow[0]?.qNum ??
          //   null;
          const value = res?.model?.layout?.style?.label;
          position === 1 && setBigNumberPorcente01(value);
          position === 2 && setBigNumberPorcente02(value);
          position === 3 && setBigNumberPorcente03(value);
          position === 4 && setBigNumberPorcente04(value);
          position === 5 && setBigNumberPorcente05(value);
          position === 6 && setBigNumberPorcente06(value);
          position === 7 && setBigNumberPorcente07(value);
        });
      }
    },
    [app]
  );

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const getNameVariable = async (titleObjetc, position) => {
    try {
      const variableModel = await app.variable.getByName(titleObjetc);
      const layout = await variableModel.getLayout();
      position === 1 && setTitleTable01(layout.qText);
      position === 2 && setTitleTable02(layout.qText);

      position === 3 && setTextCurrentBigNumber(layout.qText);
      position === 4 && setTextprevetBigNumber(layout.qText);
      position === 5 && setTextdeltaBigNumber(layout.qText);

      position === 6 && setSubTitle01(layout.qText);
    } catch (error) {
      console.error("Erro ao obter a variável:", error);
    }
  };
  useEffect(() => {
    if (app) {
      getBigNumberCurrent(OBJECTS_BIGNUMBERS[0].CURRENT, 1);
      getBigNumberValue(OBJECTS_BIGNUMBERS[0].VALUE, 1);
      getBigNumberPorcente(OBJECTS_BIGNUMBERS[0].PORCENT, 1);

      getBigNumberCurrent(OBJECTS_BIGNUMBERS[1].CURRENT, 2);
      getBigNumberValue(OBJECTS_BIGNUMBERS[1].VALUE, 2);
      getBigNumberPorcente(OBJECTS_BIGNUMBERS[1].PORCENT, 2);

      getBigNumberCurrent(OBJECTS_BIGNUMBERS[2].CURRENT, 3);
      getBigNumberValue(OBJECTS_BIGNUMBERS[2].VALUE, 3);
      getBigNumberPorcente(OBJECTS_BIGNUMBERS[2].PORCENT, 3);

      getBigNumberCurrent(OBJECTS_BIGNUMBERS[3].CURRENT, 4);
      getBigNumberValue(OBJECTS_BIGNUMBERS[3].VALUE, 4);
      getBigNumberPorcente(OBJECTS_BIGNUMBERS[3].PORCENT, 4);

      getBigNumberCurrent(OBJECTS_BIGNUMBERS[4].CURRENT, 5);
      getBigNumberValue(OBJECTS_BIGNUMBERS[4].VALUE, 5);
      getBigNumberPorcente(OBJECTS_BIGNUMBERS[4].PORCENT, 5);

      getBigNumberCurrent(OBJECTS_BIGNUMBERS[5].CURRENT, 6);
      getBigNumberValue(OBJECTS_BIGNUMBERS[5].VALUE, 6);
      getBigNumberPorcente(OBJECTS_BIGNUMBERS[5].PORCENT, 6);

      getBigNumberCurrent(OBJECTS_BIGNUMBERS[6].CURRENT, 7);
      getBigNumberValue(OBJECTS_BIGNUMBERS[6].VALUE, 7);
      getBigNumberPorcente(OBJECTS_BIGNUMBERS[6].PORCENT, 7);

      getBigNumberCurrent(OBJECTS_BIGNUMBERS[7].CURRENT, 8);
      getBigNumberValue(OBJECTS_BIGNUMBERS[7].VALUE, 8);
      getBigNumberPorcente(OBJECTS_BIGNUMBERS[7].PORCENT, 8);

      // Subtítulo fixo, sem chamada de variável
    }
  }, [
    app,
    getBigNumberTitle,
    getBigNumberValue,
    getBigNumberCurrent,
    getBigNumberPorcente,
    selections,
  ]);

  // Define títulos fixos dos cards sem buscar variáveis do Qlik
  useEffect(() => {
    setBigNumberTitle01(HARD_TITLES_OVERVIEW[0]);
    setBigNumberTitle02(HARD_TITLES_OVERVIEW[1]);
    setBigNumberTitle03(HARD_TITLES_OVERVIEW[2]);
    setBigNumberTitle04(HARD_TITLES_OVERVIEW[3]);
    setBigNumberTitle05(HARD_TITLES_OVERVIEW[4]);
    setBigNumberTitle06(HARD_TITLES_OVERVIEW[5]);
    setBigNumberTitle07(HARD_TITLES_OVERVIEW[6]);
    setBigNumberTitle08(HARD_TITLES_OVERVIEW[7]);
  }, []);

  useEffect(() => {
    // Títulos fixos definidos acima; sem chamadas de variáveis Qlik para 1 e 2
    // Labels fixos para Atual/Anterior/Var %, sem chamadas de variável
    getNameVariable("vTexto_Periodos", 6);
  }, [getNameVariable, selections, app]);

  const handleChange = (event) => {
    app.field("Analise_Periodo").selectMatch(event.target.value, true);
    setSelectedValue(event.target.value);
  };

  const handleKpiChange = (event) => {
    app.field("NomeTOP").selectMatch(event.target.value, true);
    setSelectedKpiValue(event.target.value);
  };

  useEffect(() => {
    if (!app || kpiDefaultAppliedRef.current) return;
    kpiDefaultAppliedRef.current = true;

    (async () => {
      try {
        const data = await app.field("NomeTOP").getData();
        const rows = data?.rows || [];
        const hasSelection = rows.some((r) => r.qState === "S");
        if (hasSelection) return;

        const defaultOption = rows.some(
          (r) => (r?.qText || "").trim() === "TOP 10 Farma"
        )
          ? "TOP 10 Farma"
          : (rows[0]?.qText || "TOP 10 Farma").trim();

        if (!defaultOption) return;

        await app.field("NomeTOP").selectMatch(defaultOption, true);
        setSelectedKpiValue(defaultOption);
      } catch {}
    })();
  }, [app]);

  useEffect(() => {
    if (app) {
      const periodo = selections.length
        ? selections.find((s) => s?.qField === "Analise_Periodo")
        : null;
      setSelectedValue(periodo?.qSelected);

      const kpi = selections.length
        ? selections.find((s) => s?.qField === "NomeTOP")
        : null;
      setSelectedKpiValue(kpi?.qSelected || "TOP 10 Farma");
    }
  }, [app, selections]);

  return (
    <div className="app overview">
      <div className="appContent">
        <LayoutWrapper>
          <Grid
            container
            flexDirection={"column"}
            justifyContent={"flex-start"}
            gap={"14px"}
          >
            {/* Título */}
            <Grid>
              <div className="container-card-title">
                <h1 className="title">Dashboard</h1>
                <div className="container-sutitle-form">
                  <div>
                    <p className="subtitle">{subTitle}</p>

                    <p className="subtitle-02">
                      {subTitle01 === "" ? (
                        <CircularProgress size="30px" />
                      ) : (
                        <>
                          <span>Período analisado: </span>
                          <span>{subTitle01}</span>
                        </>
                      )}
                    </p>
                  </div>
                  {selectedValue === "P3M OY" && (
                    <FormControl className="container-form-control">
                      <InputLabel id="select-relatorios" className="label-select">
                        KPI
                      </InputLabel>
                      <Select
                        labelId="select-relatorios"
                        className="select"
                        value={selectedKpiValue}
                        onChange={handleKpiChange}
                      >
                        <MenuItem value="TOP 10 Farma">TOP 10 - Farma</MenuItem>
                        <MenuItem value="TOP 10 + 5 Farma">
                          TOP 10 + 5 Farma
                        </MenuItem>
                        <MenuItem value="TOP 4 Eucerin">TOP 4 Eucerin</MenuItem>
                        <MenuItem value="TOP 10 Total Nivea">
                          TOP 10 - Total Nivea
                        </MenuItem>
                      </Select>
                    </FormControl>
                  )}
                  <FormControl className="container-form-control">
                    <RadioGroup
                      defaultValue="MOM"
                      row
                      name="row-radio-buttons-group"
                      className="radio-group radio-group-button-export"
                      value={selectedValue}
                      onChange={handleChange}
                    >
                      <FormControlLabel
                        value="MOM"
                        control={
                          <Radio
                            size="small"
                            defaultChecked
                            sx={{
                              "&.Mui-checked": {
                                color: "#000B72",
                              },
                            }}
                          />
                        }
                        label="MOM"
                      />

                      <FormControlLabel
                        value="MOY"
                        control={
                          <Radio
                            size="small"
                            sx={{
                              "&.Mui-checked": {
                                color: "#000B72",
                              },
                            }}
                          />
                        }
                        label="MOY"
                      />

                      <FormControlLabel
                        value="P3M OY"
                        control={
                          <Radio
                            size="small"
                            sx={{
                              "&.Mui-checked": {
                                color: "#000B72",
                              },
                            }}
                          />
                        }
                        label="P3M OY"
                      />

                      <FormControlLabel
                        value="YTD OY"
                        control={
                          <Radio
                            size="small"
                            sx={{
                              "&.Mui-checked": {
                                color: "#000B72",
                              },
                            }}
                          />
                        }
                        label="YTD OY"
                        sx={{ marginRight: 0 }}
                      />
                    </RadioGroup>
                  </FormControl>
                </div>
              </div>
            </Grid>

            <Grid container className={`container-bigNumbers`}>
              <Card
                app={app}
                header={{
                  hardTitle: bigNumberTitle01,
                }}
                className={`card-bigNumbers ${
                  OBJECTS_BIGNUMBERS[0].DESTAQUE && "card-border-destaque"
                } ${selectedValue === "P3M OY" && "card-bigNumbers-expand"}`}
              >
                <div className="contentCardBigNumber">
                  <div className="content-left-info">
                    <p className="item-current">
                      <span className="item-current-value">
                        {bigNumberCurrent01 === "" ? (
                          <CircularProgress size="30px" />
                        ) : (
                          bigNumberCurrent01
                        )}{" "}
                      </span>
                      <span className="item-current-text">
                        {" "}
                        {textCurrentBigNumber === "" ? (
                          <CircularProgress size="30px" />
                        ) : (
                          textCurrentBigNumber
                        )}{" "}
                      </span>
                    </p>

                    <p className="item-preview-current">
                      <span className="item-preview-current-value">
                        {bigNumberValue01 === "" ? (
                          <CircularProgress size="30px" />
                        ) : (
                          bigNumberValue01
                        )}{" "}
                      </span>
                      <span className="item-preview-current-text">
                        {textprevetBigNumber === "" ? (
                          <CircularProgress size="30px" />
                        ) : (
                          textprevetBigNumber
                        )}
                      </span>
                    </p>
                  </div>

                  <div className="content-right-info">
                    <div
                      className={
                        !bigNumberPorcente01.includes("-")
                          ? "info-porcent info-porcent-positive"
                          : "info-porcent info-porcent-negative"
                      }
                    >
                      <span className="icon-arrows">
                        {!bigNumberPorcente01.includes("-") ? (
                          <IconPorcentePositive />
                        ) : (
                          <IconPorcenteNegative />
                        )}
                      </span>
                      <span className="porcent-info">
                        {bigNumberPorcente01 === "" ? (
                          <CircularProgress size="30px" />
                        ) : (
                          bigNumberPorcente01
                        )}
                      </span>
                    </div>

                    <span className="item-text">
                      {textdeltaBigNumber === "" ? (
                        <CircularProgress size="30px" />
                      ) : (
                        textdeltaBigNumber
                      )}
                    </span>
                  </div>
                </div>
              </Card>

              <Card
                app={app}
                header={{
                  hardTitle: bigNumberTitle02,
                }}
                className={`card-bigNumbers ${
                  OBJECTS_BIGNUMBERS[1].DESTAQUE && "card-border-destaque"
                } ${selectedValue === "P3M OY" && "card-bigNumbers-expand"}`}
              >
                <div className="contentCardBigNumber">
                  <div className="content-left-info">
                    <p className="item-current">
                      <span className="item-current-value">
                        {bigNumberCurrent02 === "" ? (
                          <CircularProgress size="30px" />
                        ) : (
                          bigNumberCurrent02
                        )}{" "}
                      </span>
                      <span className="item-current-text">
                        {" "}
                        {textCurrentBigNumber === "" ? (
                          <CircularProgress size="30px" />
                        ) : (
                          textCurrentBigNumber
                        )}{" "}
                      </span>
                    </p>

                    <p className="item-preview-current">
                      <span className="item-preview-current-value">
                        {bigNumberValue02 === "" ? (
                          <CircularProgress size="30px" />
                        ) : (
                          bigNumberValue02
                        )}{" "}
                      </span>
                      <span className="item-preview-current-text">
                        {textprevetBigNumber === "" ? (
                          <CircularProgress size="30px" />
                        ) : (
                          textprevetBigNumber
                        )}
                      </span>
                    </p>
                  </div>

                  <div className="content-right-info">
                    <div
                      className={
                        !bigNumberPorcente02.includes("-")
                          ? "info-porcent info-porcent-positive"
                          : "info-porcent info-porcent-negative"
                      }
                    >
                      <span className="icon-arrows">
                        {!bigNumberPorcente02.includes("-") ? (
                          <IconPorcentePositive />
                        ) : (
                          <IconPorcenteNegative />
                        )}
                      </span>
                      <span className="porcent-info">
                        {bigNumberPorcente02 === "" ? (
                          <CircularProgress size="30px" />
                        ) : (
                          bigNumberPorcente02
                        )}
                      </span>
                    </div>

                    <span className="item-text">
                      {textdeltaBigNumber === "" ? (
                        <CircularProgress size="30px" />
                      ) : (
                        textdeltaBigNumber
                      )}
                    </span>
                  </div>
                </div>
              </Card>

              <Card
                app={app}
                header={{
                  hardTitle: bigNumberTitle03,
                }}
                className={`card-bigNumbers ${
                  OBJECTS_BIGNUMBERS[2].DESTAQUE && "card-border-destaque"
                } ${selectedValue === "P3M OY" && "card-bigNumbers-expand"}`}
              >
                <div className="contentCardBigNumber">
                  <div className="content-left-info">
                    <p className="item-current">
                      <span className="item-current-value">
                        {bigNumberCurrent03 === "" ? (
                          <CircularProgress size="30px" />
                        ) : (
                          bigNumberCurrent03
                        )}{" "}
                      </span>
                      <span className="item-current-text">
                        {" "}
                        {textCurrentBigNumber === "" ? (
                          <CircularProgress size="30px" />
                        ) : (
                          textCurrentBigNumber
                        )}{" "}
                      </span>
                    </p>

                    <p className="item-preview-current">
                      <span className="item-preview-current-value">
                        {bigNumberValue03 === "" ? (
                          <CircularProgress size="30px" />
                        ) : (
                          bigNumberValue03
                        )}{" "}
                      </span>
                      <span className="item-preview-current-text">
                        {textprevetBigNumber === "" ? (
                          <CircularProgress size="30px" />
                        ) : (
                          textprevetBigNumber
                        )}
                      </span>
                    </p>
                  </div>

                  <div className="content-right-info">
                    <div
                      className={
                        !bigNumberPorcente03.includes("-")
                          ? "info-porcent info-porcent-positive"
                          : "info-porcent info-porcent-negative"
                      }
                    >
                      <span className="icon-arrows">
                        {!bigNumberPorcente03.includes("-") ? (
                          <IconPorcentePositive />
                        ) : (
                          <IconPorcenteNegative />
                        )}
                      </span>
                      <span className="porcent-info">
                        {bigNumberPorcente03 === "" ? (
                          <CircularProgress size="30px" />
                        ) : (
                          bigNumberPorcente03
                        )}
                      </span>
                    </div>

                    <span className="item-text">
                      {textdeltaBigNumber === "" ? (
                        <CircularProgress size="30px" />
                      ) : (
                        textdeltaBigNumber
                      )}
                    </span>
                  </div>
                </div>
              </Card>

              <Card
                app={app}
                header={{
                  hardTitle: bigNumberTitle04,
                }}
                className={`card-bigNumbers ${
                  OBJECTS_BIGNUMBERS[3].DESTAQUE && "card-border-destaque"
                } ${selectedValue === "P3M OY" && "card-bigNumbers-expand"}`}
              >
                <div className="contentCardBigNumber">
                  <div className="content-left-info">
                    <p className="item-current">
                      <span className="item-current-value">
                        {bigNumberCurrent04 === "" ? (
                          <CircularProgress size="30px" />
                        ) : (
                          bigNumberCurrent04
                        )}{" "}
                      </span>
                      <span className="item-current-text">
                        {" "}
                        {textCurrentBigNumber === "" ? (
                          <CircularProgress size="30px" />
                        ) : (
                          textCurrentBigNumber
                        )}{" "}
                      </span>
                    </p>

                    <p className="item-preview-current">
                      <span className="item-preview-current-value">
                        {bigNumberValue04 === "" ? (
                          <CircularProgress size="30px" />
                        ) : (
                          bigNumberValue04
                        )}{" "}
                      </span>
                      <span className="item-preview-current-text">
                        {textprevetBigNumber === "" ? (
                          <CircularProgress size="30px" />
                        ) : (
                          textprevetBigNumber
                        )}
                      </span>
                    </p>
                  </div>

                  <div className="content-right-info">
                    <div
                      className={
                        !bigNumberPorcente04.includes("-")
                          ? "info-porcent info-porcent-positive"
                          : "info-porcent info-porcent-negative"
                      }
                    >
                      <span className="icon-arrows">
                        {!bigNumberPorcente04.includes("-") ? (
                          <IconPorcentePositive />
                        ) : (
                          <IconPorcenteNegative />
                        )}
                      </span>
                      <span className="porcent-info">
                        {bigNumberPorcente04 === "" ? (
                          <CircularProgress size="30px" />
                        ) : (
                          bigNumberPorcente04
                        )}
                      </span>
                    </div>

                    <span className="item-text">
                      {textdeltaBigNumber === "" ? (
                        <CircularProgress size="30px" />
                      ) : (
                        textdeltaBigNumber
                      )}
                    </span>
                  </div>
                </div>
              </Card>

              <Card
                app={app}
                header={{
                  hardTitle: bigNumberTitle05,
                }}
                className={`card-bigNumbers ${
                  OBJECTS_BIGNUMBERS[4].DESTAQUE && "card-border-destaque"
                } ${selectedValue === "P3M OY" && "card-bigNumbers-expand"}`}
              >
                <div className="contentCardBigNumber">
                  <div className="content-left-info">
                    <p className="item-current">
                      <span className="item-current-value">
                        {bigNumberCurrent05 === "" ? (
                          <CircularProgress size="30px" />
                        ) : (
                          bigNumberCurrent05
                        )}{" "}
                      </span>
                      <span className="item-current-text">
                        {" "}
                        {textCurrentBigNumber === "" ? (
                          <CircularProgress size="30px" />
                        ) : (
                          textCurrentBigNumber
                        )}{" "}
                      </span>
                    </p>

                    <p className="item-preview-current">
                      <span className="item-preview-current-value">
                        {bigNumberValue05 === "" ? (
                          <CircularProgress size="30px" />
                        ) : (
                          bigNumberValue05
                        )}{" "}
                      </span>
                      <span className="item-preview-current-text">
                        {textprevetBigNumber === "" ? (
                          <CircularProgress size="30px" />
                        ) : (
                          textprevetBigNumber
                        )}
                      </span>
                    </p>
                  </div>

                  <div className="content-right-info">
                    <div
                      className={
                        !bigNumberPorcente05.includes("-")
                          ? "info-porcent info-porcent-positive"
                          : "info-porcent info-porcent-negative"
                      }
                    >
                      <span className="icon-arrows">
                        {!bigNumberPorcente05.includes("-") ? (
                          <IconPorcentePositive />
                        ) : (
                          <IconPorcenteNegative />
                        )}
                      </span>
                      <span className="porcent-info">
                        {bigNumberPorcente05 === "" ? (
                          <CircularProgress size="30px" />
                        ) : (
                          bigNumberPorcente05
                        )}
                      </span>
                    </div>

                    <span className="item-text">
                      {textdeltaBigNumber === "" ? (
                        <CircularProgress size="30px" />
                      ) : (
                        textdeltaBigNumber
                      )}
                    </span>
                  </div>
                </div>
              </Card>

              <Card
                app={app}
                header={{
                  hardTitle: bigNumberTitle06,
                }}
                className={`card-bigNumbers ${
                  OBJECTS_BIGNUMBERS[5].DESTAQUE && "card-border-destaque"
                } ${selectedValue === "P3M OY" && "card-bigNumbers-expand"}`}
              >
                <div className="contentCardBigNumber">
                  <div className="content-left-info">
                    <p className="item-current">
                      <span className="item-current-value">
                        {bigNumberCurrent06 === "" ? (
                          <CircularProgress size="30px" />
                        ) : (
                          bigNumberCurrent06
                        )}{" "}
                      </span>
                      <span className="item-current-text">
                        {" "}
                        {textCurrentBigNumber === "" ? (
                          <CircularProgress size="30px" />
                        ) : (
                          textCurrentBigNumber
                        )}{" "}
                      </span>
                    </p>

                    <p className="item-preview-current">
                      <span className="item-preview-current-value">
                        {bigNumberValue06 === "" ? (
                          <CircularProgress size="30px" />
                        ) : (
                          bigNumberValue06
                        )}{" "}
                      </span>
                      <span className="item-preview-current-text">
                        {textprevetBigNumber === "" ? (
                          <CircularProgress size="30px" />
                        ) : (
                          textprevetBigNumber
                        )}
                      </span>
                    </p>
                  </div>

                  <div className="content-right-info">
                    <div
                      className={
                        !bigNumberPorcente06.includes("-")
                          ? "info-porcent info-porcent-positive"
                          : "info-porcent info-porcent-negative"
                      }
                    >
                      <span className="icon-arrows">
                        {!bigNumberPorcente06.includes("-") ? (
                          <IconPorcentePositive />
                        ) : (
                          <IconPorcenteNegative />
                        )}
                      </span>
                      <span className="porcent-info">
                        {bigNumberPorcente06 === "" ? (
                          <CircularProgress size="30px" />
                        ) : (
                          bigNumberPorcente06
                        )}
                      </span>
                    </div>

                    <span className="item-text">
                      {textdeltaBigNumber === "" ? (
                        <CircularProgress size="30px" />
                      ) : (
                        textdeltaBigNumber
                      )}
                    </span>
                  </div>
                </div>
              </Card>
              {selectedValue === "P3M OY" ? (
                <>
                  <Card
                    app={app}
                    header={{
                      hardTitle: bigNumberTitle07,
                    }}
                    className={`card-bigNumbers ${
                      OBJECTS_BIGNUMBERS[6].DESTAQUE &&
                      "card-border-destaque-02"
                    } ${
                      selectedValue === "P3M OY" && "card-bigNumbers-expand"
                    }`}
                  >
                    <div className="contentCardBigNumber">
                      <div className="content-left-info">
                        <p className="item-current">
                          <span className="item-current-value">
                            {bigNumberCurrent07 === "" ? (
                              <CircularProgress size="30px" />
                            ) : (
                              bigNumberCurrent07
                            )}{" "}
                          </span>
                          <span className="item-current-text">
                            {" "}
                            {textCurrentBigNumber === "" ? (
                              <CircularProgress size="30px" />
                            ) : (
                              textCurrentBigNumber
                            )}{" "}
                          </span>
                        </p>

                        <p className="item-preview-current">
                          <span className="item-preview-current-value">
                            {bigNumberValue07 === "" ? (
                              <CircularProgress size="30px" />
                            ) : (
                              bigNumberValue07
                            )}{" "}
                          </span>
                          <span className="item-preview-current-text">
                            {textprevetBigNumber === "" ? (
                              <CircularProgress size="30px" />
                            ) : (
                              textprevetBigNumber
                            )}
                          </span>
                        </p>
                      </div>

                      <div className="content-right-info">
                        <div
                          className={
                            !bigNumberPorcente07.includes("-")
                              ? "info-porcent info-porcent-positive"
                              : "info-porcent info-porcent-negative"
                          }
                        >
                          <span className="icon-arrows">
                            {!bigNumberPorcente07.includes("-") ? (
                              <IconPorcentePositive />
                            ) : (
                              <IconPorcenteNegative />
                            )}
                          </span>
                          <span className="porcent-info">
                            {bigNumberPorcente07 === "" ? (
                              <CircularProgress size="30px" />
                            ) : (
                              bigNumberPorcente07
                            )}
                          </span>
                        </div>

                        <span className="item-text">
                          {textdeltaBigNumber === "" ? (
                            <CircularProgress size="30px" />
                          ) : (
                            textdeltaBigNumber
                          )}
                        </span>
                      </div>
                    </div>
                  </Card>

                  <Card
                    app={app}
                    header={{
                      hardTitle: bigNumberTitle08,
                    }}
                    className={`card-bigNumbers ${
                      OBJECTS_BIGNUMBERS[7].DESTAQUE &&
                      "card-border-destaque-02"
                    } ${
                      selectedValue === "P3M OY" && "card-bigNumbers-expand"
                    }`}
                  >
                    <div className="contentCardBigNumber">
                      <div className="content-left-info">
                        <p className="item-current">
                          <span className="item-current-value">
                            {bigNumberCurrent08 === "" ? (
                              <CircularProgress size="30px" />
                            ) : (
                              bigNumberCurrent08
                            )}{" "}
                          </span>
                          <span className="item-current-text">
                            {" "}
                            {textCurrentBigNumber === "" ? (
                              <CircularProgress size="30px" />
                            ) : (
                              textCurrentBigNumber
                            )}{" "}
                          </span>
                        </p>

                        <p className="item-preview-current">
                          <span className="item-preview-current-value">
                            {bigNumberValue08 === "" ? (
                              <CircularProgress size="30px" />
                            ) : (
                              bigNumberValue08
                            )}{" "}
                          </span>
                          <span className="item-preview-current-text">
                            {textprevetBigNumber === "" ? (
                              <CircularProgress size="30px" />
                            ) : (
                              textprevetBigNumber
                            )}
                          </span>
                        </p>
                      </div>
                    </div>
                  </Card>
                </>
              ) : null}
            </Grid>

            <Grid className="container-resultados">
              <Card
                app={app}
                header={{
                  hardTitle: titleTable01,
                }}
                exportContainer
                exportTable
                exportTableId={OBJECTS_ID.TATLE_01}
                expandable
                className="container-table-resultados"
              >
                <div className="input-filter">
                  <NativeObject
                    app={app}
                    key={OBJECTS_ID.INPUT_RESUL}
                    reference={{ id: OBJECTS_ID.INPUT_RESUL }}
                    style={{
                      width: "316PX",
                      height: "46px",
                    }}
                  />
                </div>

                <NativeObject
                  app={app}
                  key={OBJECTS_ID.TATLE_01}
                  reference={{ id: OBJECTS_ID.TATLE_01 }}
                  style={{
                    width: "100%",
                    height: "450px",
                  }}
                />
              </Card>
            </Grid>

            <Grid className="container-evolucao">
              <Card
                app={app}
                header={{
                  hardTitle: titleTable02,
                }}
                exportContainer
                exportTable
                exportTableId={OBJECTS_ID.TATLE_02}
                expandable
                className="container-table-evolucao"
              >
                <div className="container-inputs">
                  <NativeObject
                    className={"input-filter input-filter-01"}
                    app={app}
                    key={OBJECTS_ID.INPUT_MEDIA}
                    reference={{ id: OBJECTS_ID.INPUT_MEDIA }}
                    style={{
                      height: "46px",
                    }}
                  />
                  <NativeObject
                    className={"input-filter input-filter-02"}
                    app={app}
                    key={OBJECTS_ID.INPUT_PERIO}
                    reference={{ id: OBJECTS_ID.INPUT_PERIO }}
                    style={{
                      height: "46px",
                    }}
                  />
                </div>

                <NativeObject
                  app={app}
                  key={OBJECTS_ID.TATLE_02}
                  reference={{ id: OBJECTS_ID.TATLE_02 }}
                  style={{
                    width: "100%",
                    height: "450px",
                  }}
                />
              </Card>
            </Grid>

            <Footer app={app} />
          </Grid>
        </LayoutWrapper>
      </div>
    </div>
  );
}

OverviewDesktop.defaultProps = {
  app: null,
  config: {},
};

OverviewDesktop.propTypes = {
  app: PropTypes.object,
  config: PropTypes.object,
};

export default OverviewDesktop;
